interface Props {
  width?: string;
  height?: string;
  stroke?: string;
  className?: string;
}

const Document = ({
  width = '48',
  height = '48',
  stroke = '#1a1818',
  className = 'Document',
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 12.7 12.7"
    width={width}
    height={height}
    className={className}
    transform="scale(1.3)"
  >
    <g
      fill="none"
      stroke={stroke}
      strokeDasharray="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="4"
      strokeOpacity="1"
      strokeWidth="0.529"
    >
      <path d="M7.503 2.134v2.329h2.121" opacity="1" stopOpacity="1" />
      <path
        d="M7.3 2.13H3.07v8.44H9.63V4.468L7.5 2.13z"
        opacity="1"
        stopOpacity="1"
      />
    </g>
  </svg>
);

export default Document;
